var LuminanceUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
/**
 * @category Unit
 */
let LuminanceUnit = LuminanceUnit_1 = class LuminanceUnit extends Unit {};
LuminanceUnit.LUMEN = new LuminanceUnit_1('lumen', {
  baseName: 'luminance',
  aliases: ['lm'],
  prefixes: 'decimal'
});
LuminanceUnit = LuminanceUnit_1 = __decorate([SerializableObject()], LuminanceUnit);
export { LuminanceUnit };